import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import OnboardingContainer from '../Component/OnboardingContainer';
import { ScreenBackV2WithTitle } from '../../Components/ScreenBackV2';
import OTPInput from '../Component/OtpInput';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  LoginOtpAction,
  SendOTPByPhoneNow,
  sendOtpForSignUpAction,
  verifySignUpOtpAction,
} from '../auth/action';
import ResendOtp from '../Component/ResendOtp';
import { useDispatch } from 'react-redux';
import { onLoggedIn } from '../../Function/onLoggedIn';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const VerifyV2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { phone_number, tnc } = location.state || {};

  const routeName = location.pathname;
  const isNewUserRegistration = routeName === '/VerifyUserForRegister';
  const isLoginViaOTP = routeName === '/LoginViaOtp';
  const isForgotPassword = routeName === '/VerifyUserForForgotPassword';

  const sendOTPHandler = async () => {
    let response = {};

    if (isNewUserRegistration)
      response = await sendOtpForSignUpAction(phone_number, tnc);
    else if (isLoginViaOTP || isForgotPassword)
      response = await SendOTPByPhoneNow(phone_number);

    const { error, message } = response;

    if (error) {
      if (message === 'User already exists for that phone number')
        navigate('/login');

      return toast.error(message);
    } else {
      return toast.success(message);
    }
  };

  useEffect(() => {
    sendOTPHandler();
  }, []);

  const [otp, setOtp] = useState('');
  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };
  const onFinish = async () => {
    if (!otp || otp.length < 4) return toast.error('Please enter a valid OTP');

    if (isForgotPassword)
      return navigate('/ForgotPassword', {
        state: {
          phone_number: phone_number,
          otp: otp,
        },
      });
    if (isNewUserRegistration) {
      const payload = {
        phone_number: phone_number,
        otp: otp,
      };

      const { error, message } = await verifySignUpOtpAction(payload);
      if (!error) {
        navigate('/CreatePassword', {
          state: {
            phone_number: phone_number,
          },
        });
        return toast.success('OTP verified successfully');
      } else return toast.error(message);
    } else if (isLoginViaOTP) {
      const { data, error, message } = await LoginOtpAction(phone_number, otp);

      onLoggedIn({
        data: data,
        error: error,
        message: message,
        navigate: navigate,
        dispatch: dispatch,
        toast: toast,
      });
    }
  };

  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle title={'Verify OTP'} />
      <Box>
        <Typography
          variant='h5'
          gutterBottom
          color={'white'}
          fontSize={'2rem'}
        ></Typography>
        <Typography
          variant='subtitle2'
          gutterBottom
          color={'#ffffff'}
          fontSize={'1rem'}
          sx={{ mt: '2rem', mb: '1rem' }}
        >
          Enter the OTP sent to {phone_number}
        </Typography>
        <OTPInput onOtpChange={handleOtpChange} />
        <ResendOtp onResend={sendOTPHandler} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            variant='contained'
            sx={{ mt: '2rem', width: '100%' }}
            onClick={onFinish}
          >
            Verify
          </Button>
        </Box>
      </Box>
    </OnboardingContainer>
  );
};

export default VerifyV2;
